export default "__VITE_ASSET__WOc4Jb1g__"